(function () {
    "use strict";

    var LabelValueTableControl = Solovis.defineClass(
        "Solovis.Reports.Parts.Tables.LabelValueTableControl",
        Solovis.Reports.Parts.PartControl,
        function (options) {
            this.dataSets = null;

            this._modelEnvironmentSettings = this.settings.modelEnvironment ? this.settings.modelEnvironment : null;

            this._labelWidth = this.settings.labelWidth ? this.settings.labelWidth : "120px";

        });   


    LabelValueTableControl.prototype.doInit = function () {
    };

    LabelValueTableControl.prototype.doRender = function () {
        var self = this;

        this.container.html("");

        if (!this.dataSets) {
            return;
        }

        this._moreVisible = false;

        var context = {
            dataSets: this.dataSets,
            parameters: this.parameters
        };

        if (this._modelEnvironmentSettings) {            
            if (this._modelEnvironmentSettings.path) {
                var modelEnvData = Solovis.resolveObject(this._modelEnvironmentSettings.path, this.dataSets);
                if (modelEnvData) {
                    if (modelEnvData instanceof InvData.ModelEnvironment) {
                        this.modelEnvironment = modelEnvData;
                    }
                    else {
                        // We only have the json data for the environment so load it into the wrapper class.
                        this.modelEnvironment = new InvData.ModelEnvironment();
                        this.modelEnvironment.mergeEnvironmentData(modelEnvData);
                    }
                }
            }
        }

        var rows = this.settings.rows ? this.settings.rows : null;
        if (typeof rows == "function") {
            rows = rows.call(this);
        }

        var table = $("<table>").addClass("table table-striped table-condensed")
            .css("margin-top", "0px")
            .appendTo(this.container);

        this._tbody = $("<tbody>").appendTo(table);

        var hasMoreDataRow = false;

        $(rows).each(function (i, rowData: any) {
            self._createRow(rowData, self._tbody, context);

            if (rowData.moreData) {
                hasMoreDataRow = true;
            }
        });

        if (hasMoreDataRow && !this.reportControl.printMode) {
            var toggleMoreRow = $("<tr>").appendTo(this._tbody).css("cursor", "pointer");
            var spaceCell = $("<td>").appendTo(toggleMoreRow);
            var toggleMoreCell = $("<td>").appendTo(toggleMoreRow);

            this._showMoreLink = $("<a>").text("more").appendTo(toggleMoreCell)
                .click(function () {                  
                });

            this._showLessLink = $("<a>").text("less").css("display", "none").appendTo(toggleMoreCell)
                .click(function () {                    
                });

            toggleMoreRow.click(function () {
                self._toggleMoreVisible();
            });
        }
    };

    LabelValueTableControl.prototype._toggleMoreVisible = function () {
        if (this._moreVisible) {
            this._showLessLink.toggle(false);
            this._showMoreLink.toggle(true);
            this._tbody.children(".label-value-table-more-data-row").toggle(false);
            this._moreVisible = false;
        }
        else {
            this._showMoreLink.toggle(false);
            this._showLessLink.toggle(true);
            this._tbody.children(".label-value-table-more-data-row").toggle(true);
            this._moreVisible = true;
        }
    };

    LabelValueTableControl.prototype._createRow = function (rowData, rowContainer, context) {
        var self = this;

        var data = null;
        if (rowData.data) {
            data = Solovis.resolveObject(rowData.data, context);
        }

        var valueContext = {
            col: rowData,
            dataContext: context,
            modelEnvironment: self.modelEnvironment,
            reportControl: self.reportControl,
            defaultFormatter: Solovis.Reports.Formatter.formatValueAsHtml
        };

        var label = rowData.label;

        var valueHtml;
        if (rowData.htmlFormatter) {
            valueHtml = rowData.htmlFormatter(data, valueContext);
        }
        else {
            valueHtml = Solovis.Reports.Formatter.formatValueAsHtml(data, valueContext);
        }

        var tableRow = $("<tr>").appendTo(rowContainer);

        if (rowData.moreData && !this.reportControl.printMode) {
            tableRow.css("display", "none");
            tableRow.addClass("label-value-table-more-data-row");
        }

        var rowLabel = $("<td>").addClass("row-label").text(label).appendTo(tableRow);
        rowLabel.css("width", this._labelWidth);

        var rowValue = $("<td>").addClass("row-value").html(valueHtml).appendTo(tableRow);
    };

})();
